import { BasicService } from "@/services/basic";
import { createGetUrlWithOptions } from "@/helpers/services";
export class Zones extends BasicService {
    constructor(axios) {
        super(axios);
        this.baseURL = "zones";
    }
    async get(options) {
        try {
            const url = createGetUrlWithOptions(this.baseURL, options);
            const { data } = await this.$get(url);
            return Promise.resolve(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async add(zone) {
        try {
            await this.$post(this.baseURL, zone);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async edit(zone) {
        try {
            await this.$put(`${this.baseURL}/${zone.id}`, zone);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async delete(zonesId) {
        try {
            await this.$delete(`${this.baseURL}/${zonesId}`);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
